// services/admin/tagService.js
import { apiClient } from './apiClient';

export const tagService = {
  /**
   * Получить все теги
   * @returns {Promise<Tag[]>}
   */
  async getAllTags() {
    return apiClient.get('/tags');
  },

  /**
   * Получить тег по ID
   * @param {number} id
   * @returns {Promise<Tag>}
   */
  async getTagById(id) {
    return apiClient.get(`/tags/${id}`);
  },

  /**
   * Создание тега
   * @param {string} name
   * @param {string} color
   * @returns {Promise<Tag>}
   */
  async createTag(name, color) {
    const params = new URLSearchParams();
    params.append('name', name);
    params.append('color', color);

    const url = `${apiClient.baseUrl}/tags?${params.toString()}`;
    console.log('POST запрос к:', url);

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.message || 'Ошибка при создании тега');
    }

    const result = await response.json();
    console.log('Ответ сервера:', result);

    // Возвращаем результат напрямую (без обёртки data)
    return result;
  },

  /**
   * Обновление тега
   * @param {number} id
   * @param {string} name
   * @param {string} color
   * @returns {Promise<Tag>}
   */
  async updateTag(id, name, color) {
    const params = new URLSearchParams();
    params.append('name', name);
    params.append('color', color);

    const url = `${apiClient.baseUrl}/tags/${id}?${params.toString()}`;
    console.log('PUT запрос к:', url);

    const response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.message || 'Ошибка при обновлении тега');
    }

    const result = await response.json();
    console.log('Ответ сервера:', result);

    return result;
  },

  /**
   * Удаление тега
   * @param {number} id
   * @returns {Promise<void>}
   */
  async deleteTag(id) {
    return apiClient.delete(`/tags/${id}`);
  },

  /**
   * Обновление списка локаций для тега
   * @param {number} tagId
   * @param {number[]} locationIds
   * @returns {Promise<void>}
   */
  async updateTagLocations(tagId, locationIds) {
    if (!tagId) {
      throw new Error('tagId обязателен');
    }

    console.log(`Обновляем локации для тега ${tagId}:`, locationIds);

    // Отправляем массив ID напрямую (без обёртки itemIds)
    return apiClient.put(`/tags/${tagId}/locations`, locationIds);
  },

  /**
   * Обновление списка маршрутов для тега
   * @param {number} tagId
   * @param {number[]} routeIds
   * @returns {Promise<void>}
   */
  async updateTagRoutes(tagId, routeIds) {
    if (!tagId) {
      throw new Error('tagId обязателен');
    }

    console.log(`Обновляем маршруты для тега ${tagId}:`, routeIds);

    // Отправляем массив ID напрямую (без обёртки itemIds)
    return apiClient.put(`/tags/${tagId}/routes`, routeIds);
  },

  /**
   * Получение всех локаций тега
   * @param {number} tagId
   * @returns {Promise<Location[]>}
   */
  async getTagLocations(tagId) {
    return apiClient.get(`/tags/${tagId}/locations`);
  },

  /**
   * Получение всех маршрутов тега
   * @param {number} tagId
   * @returns {Promise<Route[]>}
   */
  async getTagRoutes(tagId) {
    return apiClient.get(`/tags/${tagId}/routes`);
  }
};